import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response, "error.response");
    
    if (error.response) {
      const responseURL = error.response.request?.responseURL;
      const { status } = error.response;
       if (status === 401 && !responseURL.includes("/login")) {
        localStorage.clear();
        window.location.href = "/admin";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
